export const localStorageAuthUserData = () => {
    const userData = localStorage.getItem("userData");
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role")
    const isLoggedIn = localStorage.getItem("isLoggedIn");
  
    if (userData) {
      try {
        const parsedData = JSON.parse(userData);
        return { parsedData , role , token , isLoggedIn};
      } catch (error) {
        return {};
      }
    }
    return {};
};

export const userRoles= {owner:"owner" , admin : "admin" , user : "user" , subadmin : "subadmin"}

export const capitalizeWords = (str) => {
  if (!str) return "";
  
  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
    .join(" "); 
};